import { useMemo } from 'react';
import { resolveEventDetailPermission } from '../../constants/eventDetailPermissions';

type Input = {
  adminRole: string;
  isExternalAccount: boolean;
  adminPermissions: unknown[];
};

export default function useEventListPermissions({
  adminRole,
  isExternalAccount,
  adminPermissions,
}: Input) {
  return useMemo(() => {
    const allowed = (permissionKey: string) => resolveEventDetailPermission({
      role: adminRole,
      isExternalAccount,
      permissions: adminPermissions,
      permissionKey,
    });
    return {
      canViewTicketSales: allowed('EVENT_VIEW_TICKET_SALES'),
      canEditTicketSales: allowed('EVENT_EDIT_TICKET_SALES'),
      canViewCastingProgress: allowed('EVENT_VIEW_CASTING_SETTINGS'),
      canViewEventTasks: allowed('EVENT_VIEW_EVENT_TASKS'),
    };
  }, [adminPermissions, adminRole, isExternalAccount]);
}
